var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.method !== null ? '' : 'tw-text-center tw-my-5'},[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"secondary"}}):_vm._e(),_c('div',{key:_vm.reloadKey,ref:"shift4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }